var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 141,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F7D6BE",
    cx: 89.5,
    cy: 70.5,
    r: 70.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M48.682 60.265h82.385v61.918H48.682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.058 118.545a1.678 1.678 0 0 1-1.673-1.681V63.045c0-2.781 2.252-5.045 5.018-5.045h16.73c.924 0 1.673.753 1.673 1.682 0 .928-.75 1.682-1.673 1.682h-16.73c-.92 0-1.672.756-1.672 1.681v53.819c0 .928-.75 1.681-1.673 1.681zM131.691 118.545a1.678 1.678 0 0 1-1.673-1.681V63.045c0-.925-.752-1.681-1.672-1.681h-16.727a1.678 1.678 0 0 1-1.673-1.682c0-.929.75-1.682 1.673-1.682h16.727c2.766 0 5.018 2.264 5.018 5.045v53.819c0 .928-.75 1.681-1.673 1.681z",
    fill: "#263238",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "square",
    d: "M.374 100.663h47.185M131.441 100.663h47.185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.691 132H48.058c-4.613 0-8.363-3.77-8.363-8.41 0-.927.749-1.68 1.672-1.68h36.799c.923 0 1.672.753 1.672 1.68 0 .93-.749 1.683-1.672 1.683H43.328c.689 1.957 2.549 3.363 4.73 3.363h83.633c2.181 0 4.041-1.406 4.73-3.363h-34.838a1.678 1.678 0 0 1-1.673-1.682c0-.928.75-1.682 1.673-1.682h36.799c.923 0 1.672.754 1.672 1.682 0 4.638-3.75 8.409-8.363 8.409z",
    fill: "#263238",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74 60.072 16.63-22.813L105.87 60.6h-6.687l-1.05 17.423-15.536-.858V61.792c0-3.205-2.866-3.779-8.597-1.72z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.322 99a1.674 1.674 0 0 1-1.663-1.684V61.947h-4.99c-.608 0-1.17-.336-1.456-.879a1.7 1.7 0 0 1 .06-1.718L89.24 35.771c.619-.96 2.182-.96 2.8 0l14.968 23.58c.33.518.35 1.178.06 1.717-.293.543-.855.88-1.464.88h-4.989v28.63c0 .93-.745 1.685-1.663 1.685a1.674 1.674 0 0 1-1.663-1.684V60.263c0-.93.745-1.684 1.663-1.684h3.606L90.638 39.8 78.715 58.579h3.606c.918 0 1.663.754 1.663 1.684v37.053c0 .93-.745 1.684-1.663 1.684z",
    fill: "#263238",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaUpload);
export default __webpack_public_path__ + "static/media/MediaUpload.bebe0e9c.svg";
export { ForwardRef as ReactComponent };